// Firebase configuration
// This file loads Firebase configuration from publicEnv
// Make sure to set these environment variables in your deployment configuration

import publicEnv from '../publicEnv';

export const firebaseConfig = {
  apiKey: publicEnv.FIREBASE_API_KEY,
  authDomain: publicEnv.FIREBASE_AUTH_DOMAIN,
  projectId: publicEnv.FIREBASE_PROJECT_ID,
  storageBucket: publicEnv.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: publicEnv.FIREBASE_MESSAGING_SENDER_ID,
  appId: publicEnv.FIREBASE_APP_ID,
  measurementId: publicEnv.FIREBASE_MEASUREMENT_ID,
};

// Validate that required Firebase config is present
export const validateFirebaseConfig = () => {
  const requiredKeys = ['apiKey', 'authDomain', 'projectId'];
  const missingKeys = requiredKeys.filter((key) => !firebaseConfig[key]);

  if (missingKeys.length > 0) {
    console.error('Missing required Firebase configuration:', missingKeys);
    return false;
  }

  return true;
};

export default firebaseConfig;
